var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcWet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dc_wet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.78,1.17A36.13,36.13,0,1,0,73.9,37.3,36.17,36.17,0,0,0,37.78,1.17Zm0,70.25A34.13,34.13,0,1,1,71.9,37.3,34.17,34.17,0,0,1,37.78,71.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.13,47.87c0,3.68,2.37,8,7.19,8.07s7.19-4.39,7.19-8.07c0-5.18-7.61-11.79-7.19-11.94C36.74,36.08,29.13,42.69,29.13,47.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39,29.2c0,3.18,2.06,7,6.23,7s6.23-3.8,6.23-7c0-4.5-6.59-10.22-6.23-10.36C45.61,19,39,24.7,39,29.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.34,29.74c0-3.8-5.58-8.65-5.27-8.77.3.12-5.28,5-5.28,8.77,0,2.69,1.74,5.88,5.28,5.91S34.34,32.43,34.34,29.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcWet);
export default __webpack_public_path__ + "static/media/dc_wet.907d27b8161a5b4c559b6527f6e004ca.svg";
export { ForwardRef as ReactComponent };